import React from 'react'
import { styled } from '@mui/material/styles'
import { grayText, primary, warning, errorText } from '@/constant'
import { ImageIcon } from '@/icon'
import { Card, Avatar, Button } from '@mui/material'
import id_icon from '@/asset/img/id_icon.webp'
import account_icon_mail from '@/asset/img/account_icon_mail.webp'
import account_icon_mobile from '@/asset/img/account_icon_mobile.webp'
import account_icon_wechat from '@/asset/img/account_icon_wechat.webp'

const icons = {
  mail: account_icon_mail,
  mobile: account_icon_mobile,
  wechat: account_icon_wechat,
}

export const LabelIcon = ({ type }: { type: keyof typeof icons }) => {
  return <ImageIcon src={icons?.[type] as string} />
}

export const IdIcon = () => <ImageIcon src={id_icon} />

export const BasicCard = styled(Card)(() => ({
  padding: '24px',
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
}))

export const UserIcon = styled(Avatar)(() => ({
  width: '110px',
  height: '110px',
}))

export const UserName = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
}))

export const UserId = styled('div')(() => ({
  display: 'flex',
  gap: '16px',
  alignItems: 'center',
}))

export const UserInfo = styled('div')(() => ({
  display: 'flex',
  gap: '32px',
  alignItems: 'center',
  fontSize: '16px',
}))

export const UserInfoLabel = styled('div')(() => ({
  display: 'flex',
  gap: '16px',
  alignItems: 'center',
}))

export const GrayText = styled('div')(() => ({ color: grayText }))

export const BindStatus = styled('div', {
  shouldForwardProp: (prop) => prop !== 'binded',
})<{ binded: string | boolean }>(({ binded }) => ({
  display: 'flex',
  gap: '6px',
  alignItems: 'center',
  color: binded === 'true' ? primary : warning,
  '& > svg': {
    fill: binded === 'true' ? primary : warning,
  },
}))

export const Footer = styled('div')(() => ({
  display: 'flex',
  gap: '12px',
  justifyContent: 'flex-end',
}))

export const ValidationButton = styled(Button)`
  background: #eff0f0;
  line-height: 16px;
  text-align: center;
  color: #344767;
  letter-spacing: 1px;
  margin-top: 0 !important;
`

export const FlexRow = styled('div')(() => ({
  display: 'flex',
  alignItems: 'baseline',
}))

export const ErrorText = styled('span')(() => ({
  color: errorText,
}))

export const Row = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
}))
